import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Languages } from 'lucide-react';
import '../styles/Navbar.css';
import logo from './logo.png';

function Navbar() {
  const { language, toggleLanguage } = useLanguage();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="logo">
        <img src={logo} alt="Logo" />
      </div>
      <button className="mobile-menu-button" onClick={toggleMenu}>
        ☰
      </button>
      <ul className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
        <li><Link to="/" onClick={() => setIsMenuOpen(false)}>{language === 'en' ? 'Client Login' : 'Kunden-Login'}</Link></li>
        <li><Link to="/request-nda" onClick={() => setIsMenuOpen(false)}>{language === 'en' ? 'Request NDA' : 'NDA anfordern'}</Link></li>
        <li><Link to="/schedule-call" onClick={() => setIsMenuOpen(false)}>{language === 'en' ? 'Schedule a Call' : 'Termin vereinbaren'}</Link></li>
      </ul>
      <div className="nav-right">
        <button 
          className="nav-language-toggle"
          onClick={toggleLanguage}
          title={language === 'en' ? 'Switch to German' : 'Zu Englisch wechseln'}
        >
          <Languages size={20} />
          <span className="language-text">{language === 'en' ? 'DE' : 'EN'}</span>
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
